// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3J11z","title":"InfoRow_title__2nORq"};